import { render, staticRenderFns } from "./CreateContainer.vue?vue&type=template&id=4bba71c2&scoped=true"
import script from "./CreateContainer.vue?vue&type=script&lang=js"
export * from "./CreateContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bba71c2",
  null
  
)

export default component.exports